import { Box } from '@chakra-ui/react'

import type { PostContentsProps } from '@/components/Community/Post/types'
import { withErrorBoundary } from '@/components/Worlds/UI/ErrorBoundary'

import PostContentsUserPost from './internal/PostContentsUserPost'

function PostContentsInternal(props: PostContentsProps): JSX.Element {
  return (
    <Box maxWidth="100%">
      <PostContentsUserPost {...props} />
    </Box>
  )
}

const PostContents = withErrorBoundary(PostContentsInternal, () => (
  <Box maxWidth="100%">Oops! There was an error displaying this post.</Box>
))

export default PostContents
